import React from "react";

export const AverageBreakdownModal = ({ entry, floorCapacity, onClose }) => {
  React.useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  // Prevent body scroll when modal is open
  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  if (!entry || !entry.averageCount) {
    return null;
  }

  console.log('AverageBreakdownModal entry:', entry);

  const percentage = entry.averagePercentage?.toFixed(1) || 0;
  const isOverCapacity = entry.averageCount > floorCapacity;

  const sortedZones = (entry.zones || []).sort(
    (a, b) => b.averageCount - a.averageCount
  );

  const getBadgeColor = (pct) => {
    if (pct <= 33) return "success";
    if (pct <= 66) return "warning";
    if (pct <= 100) return "orange";
    return "danger";
  };

  return (
    <div className="modal modal-blur fade show" style={{ display: "block" }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Average Hour Details - {entry.hour !== undefined
                ? `${entry.hour % 12 || 12}:00 ${entry.hour >= 12 ? "PM" : "AM"}`
                : "N/A"}
            </h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <div className="d-flex align-items-center gap-2">
                <span className={`badge bg-${getBadgeColor(percentage)}`}>
                  {percentage}% Utilization
                </span>
                <span className="text-muted">
                  {entry.averageCount} / {floorCapacity}
                </span>
                {isOverCapacity && (
                  <span className="badge bg-danger">Over Capacity</span>
                )}
              </div>
            </div>

            <hr />

            {/* Zone Breakdown */}
            {sortedZones.length > 0 ? (
              <div>
                <h6 className="mb-2">Zone Breakdown:</h6>
                <div className="table-responsive">
                  <table className="table table-sm table-vcenter">
                    <thead>
                      <tr>
                        <th>Zone</th>
                        <th className="text-end">Avg Count</th>
                        <th className="text-end">Capacity</th>
                        <th className="text-end">%</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedZones.map((zone, index) => {
                        const zonePct = zone.averagePercentage?.toFixed(1) || 0;
                        return (
                          <tr key={index}>
                            <td>{zone.zoneName}</td>
                            <td className="text-end">{zone.averageCount || 0}</td>
                            <td className="text-end">{zone.capacity || 0}</td>
                            <td className="text-end">
                              <span className={`badge bg-${getBadgeColor(zonePct)}`}>
                                {zonePct}%
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="text-center text-muted py-4">
                No breakdown data available
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
